export const limitsChange = {
    showInfoMessageDelay: true,
    allowZeroLimits: true,
    validations: {
        INTERNET: {
            biggerThanPOS: true,
        },
    },
};
